import { useRecoilState } from "recoil";
import { authAtom } from "state/recoil-root";
import instance from "helpers/instance";
import { listPdfTemplateAtom } from "state/show";
import { totalRow } from "state/roles-permissions";

const usePdfTemplate = () => {
  const [auth] = useRecoilState(authAtom);
  const [, setPdfTemplateList] = useRecoilState(listPdfTemplateAtom);
  const [totalRows, setTotalRows] = useRecoilState(totalRow);

  const headers = {
    Authorization: `Bearer ${auth?.access_token}`,
  };

  return {
    getListPdfTemplate,
    getPdfTemplateDetail,
    createPdfTemplate,
    updatePdfTemplate,
    createPdfTemplateDetail,
    updatePdfTemplateDetail,
    previewPdfTemplate,
  };

  function getListPdfTemplate(filter, page = 0, pageSize = 10) {
    let params = {
      ...filter,
    };
    if (page >= 0 && pageSize > 0) {
      const offset = page * pageSize;
      params = {
        offset,
        limit: pageSize,
        ...filter,
      };
    }
    return instance({
      url: "management/v1/pdf-templates",
      method: "GET",
      headers,
      params,
    })
      .then((res) => {
        if (res.status === 200) {
          setPdfTemplateList(res.data.data || []);
          setTotalRows((preState) => ({
            ...preState,
            pdfTemplates: res.data.meta.total,
          }));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function getPdfTemplateDetail(templateId) {
    return instance({
      url: `management/v1/pdf-templates/${templateId}`,
      method: "GET",
      headers,
    });
  }

  function createPdfTemplate(data) {
    return instance({
      url: "management/v1/pdf-templates",
      method: "POST",
      data,
      headers,
    });
  }

  function updatePdfTemplate(data, templateId) {
    return instance({
      url: `management/v1/pdf-templates/${templateId}`,
      method: "PUT",
      headers,
      data,
    });
  }

  function createPdfTemplateDetail(data) {
    return instance({
      url: "management/v1/pdf-template-details",
      method: "POST",
      data,
      headers,
    });
  }

  function updatePdfTemplateDetail(data, detailId) {
    return instance({
      url: `management/v1/pdf-template-details/${detailId}`,
      method: "PUT",
      headers,
      data,
    });
  }

  function previewPdfTemplate(data) {
    return instance({
      url: "management/v1/pdf-templates/preview",
      method: "POST",
      headers,
      data,
      responseType: "blob",
    });
  }
};

export { usePdfTemplate };
